import React from 'react';
export const Breadcrumb = () => {
  return <div className="text-sm text-gray-600 px-4 md:px-6 py-2" data-id="element-102">
      Home / Anti-Aging / NAD+ Cellular Energy Formula
    </div>;
};